/**
 * Store Cabinets
 */
export default {
    state: {
        cabinets: [],
        cabinetPatrimoId : 4
    },

    mutations: {
        /**
         * Initialise le state cabinets
         */
        setCabinets: function (state, cabinets) {
            state.cabinets = cabinets
        }
    },

    actions: {
        archiveCabinet: function (context, payload) {
            payload.cabinet.is_actif = 0
            context.dispatch('saveCabinet', payload)
        },

        saveCabinet: function (context, payload) {
            axios.request({
                url: '/api/cabinet' + (payload.cabinet.id ? '/' + payload.cabinet.id : ''),
                method: payload.cabinet.id ? 'patch' : 'post',
                data: payload.cabinet
            }).then(() => {
                payload.successFunction()
            }).catch(error => {
                payload.errorFunction(error)
            }).finally(() => {
                payload.finallyFunction()
                context.dispatch('init')
            })
        },
    },

    getters: {
        /**
         * Liste d'options de cabinets
         */
        optionsCabinets: state => {
            return state.cabinets
                .filter(lieu => lieu.is_actif)
                .map(cabinet => ({label: cabinet.nom, value: cabinet.id}))
        },

        /**
         * Liste d'options de cabinets Non Archivés
         */
        optionsCabinetsNonArchive: state => {
            return state.cabinets
                .filter(cabinet => !cabinet.archive)
                .map(cabinet => ({label: cabinet.nom, value: cabinet.id}))
        }
    }
}
